import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6.92 19.0001L5 17.0801L13.06 9.00006L15 10.9401L6.92 19.0001ZM20.71 5.63006L18.37 3.29006C18 2.90006 17.35 2.90006 16.96 3.29006L13.84 6.41006L11.91 4.50006L10.5 5.91006L11.92 7.33006L3 16.2501V21.0001H7.75L16.67 12.0801L18.09 13.5001L19.5 12.0901L17.58 10.1701L20.7 7.05006C21.1 6.65006 21.1 6.00006 20.71 5.63006Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Eyedrop"
);
